import { stripHtml } from "@/main/react/page/search/searchUtils";

const BLOCK_SELECTOR = "p,div,li,br,h1,h2,h3,h4,h5,h6,blockquote,pre,figcaption";

/**
 * The share title of a post page (short-posts design D5, H0-17): the post's own title, or, for a
 * title-less (short) post, the plain text of its body, as the card already does with the excerpt.
 *
 * <p>Decoded through the DOM rather than regex-stripped, so `Tom &amp; Jerry` shares as `Tom & Jerry`
 * (`stripHtml` leaves entities encoded). Block boundaries become spaces so adjacent paragraphs do not
 * fuse. The share chokepoint bounds the length. Share payload only: the heading keeps `title`.
 */
export function shareTitleFromHtml(title: string, contentHtml: string | undefined): string {
    if (title.trim()) {
        return title;
    }
    if (!contentHtml) {
        return "";
    }
    if (typeof DOMParser === "undefined") {
        return stripHtml(contentHtml);
    }
    const body = new DOMParser().parseFromString(contentHtml, "text/html").body;
    body.querySelectorAll(BLOCK_SELECTOR).forEach((element) => element.after(" "));
    return (body.textContent ?? "").replace(/\s+/g, " ").trim();
}
